import React, { useContext, useState, useEffect } from 'react'
import EmployeeForm from '@/product/components/species/employee/EmployeeForm'
import { handleRedirectInternal } from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import AlertContext from '@/product/context/alert/alertContext'
import EmployeeContext from '@/product/context/employee/empContext'
const EmployeeManage = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const { setAlert } = useContext(AlertContext)
    const { responseStatus: responseStatusEmployee, single_employee } =
        useContext(EmployeeContext)
    const history = useHistory()
    const data = props.data
    const { user } = authContext
    const { USStates, allCountries, allStates } = commonContext
    const [initialValues, setInitialValues] = useState({
        id: 0,
        emp_email: '',
        confirm_email: '',
        emp_firstname: '',
        emp_lastname: '',
        emp_address1: '',
        emp_phone: '',
        emp_type: 'employee',
        emp_city: '',
        emp_state: '',
        emp_country: '',
        emp_zip: '',
        emp_permissions: [],
    })
    const [passwordInitialValues, setPasswordInitialValues] = useState({
        id: 0,
        change_password: true,
        password: '',
        confirm_password: '',
    })
    const resetFrom = () => {
        setInitialValues({
            id: 0,
            emp_email: '',
            confirm_email: '',
            emp_firstname: '',
            emp_lastname: '',
            emp_address1: '',
            emp_phone: '',
            emp_type: 'employee',
            emp_city: '',
            emp_state: '',
            emp_country: '',
            emp_zip: '',
            emp_permissions: [],
        })
        setPasswordInitialValues({
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        })
        // formik.handleReset()
        // formikPassword.handleReset()
        // setIsLoading(false)
    }
    const employeeFunctionEdit = (single_employee) => {
        if (single_employee.record && props.match?.params?.eid !== '0') {
            const user = single_employee.record
            setInitialValues({
                id: props.match?.params?.eid,
                emp_email: user.emp_email,
                emp_firstname: user.emp_firstname,
                emp_lastname: user.emp_lastname,
                emp_address1: user.emp_address1,
                emp_phone: user.emp_phone,
                emp_type: user.emp_type ? user.emp_type : 'employee',
                emp_city: user.emp_city,
                emp_state: user.emp_state,
                emp_country: user.emp_country,
                emp_zip: user.emp_zip,
                emp_permissions: user?.emp_permissions?.length
                    ? user.emp_permissions.split(',')
                    : [],
            })
            //setReload(!reload)
        } else {
            resetFrom()
        }
        //setIsLoading(false)
    }
    const permission = [
        {
            id: '/dashboard',
            description: 'Dashboard',
        },

        {
            id: '/listing/all',
            description: 'Products - All',
        },

        {
            id: '/add/product',
            description: 'Products - Add New',
        },

        {
            id: '/listing/open',
            description: 'Products - Active',
        },
        {
            id: '/listing/sold',
            description: 'Products - Sold',
        },
        {
            id: '/listing/unsold',
            description: 'Products - Unsold',
        },
        {
            id: '/listing/draft',
            description: 'Products - Draft',
        },
        {
            id: '/listing/escalate',
            description: 'Products - Escalated',
        },
        {
            id: '/listing/event',
            description: 'Products - Event',
        },
        {
            id: '/listing/relisted',
            description: 'Products - Relisted',
        },

        {
            id: '/auction/open',
            description: 'Events - Active',
        },
        {
            id: '/auction/upcomming',
            description: 'Events - Upcoming',
        },
        {
            id: '/auction/draft',
            description: 'Events - Draft',
        },
        {
            id: '/auction/closed',
            description: 'Events - Past',
        },

        {
            id: '/users/all',
            description: 'Users - All',
        },
        {
            id: '/users/unverified',
            description: 'Users - Awaiting Admin Approval',
        },
        {
            id: '/adduser',
            description: 'Users - Add New',
        },
        {
            id: '/users/active',
            description: 'Users - Active',
        },
        {
            id: '/users/deactivate',
            description: 'Users - Deactivated',
        },
        {
            id: '/users/rejected',
            description: 'Users - Rejected',
        },

        {
            id: '/org/all',
            description: 'Sellers - All',
        },
        {
            id: '/org/active',
            description: 'Sellers - Active',
        },
        {
            id: '/org/deactivate',
            description: 'Sellers - Deactivated',
        },
        {
            id: '/org/suspended',
            description: 'Sellers - Suspended',
        },

        {
            id: '/org/rejected',
            description: 'Sellers - Rejected',
        },
        {
            id: '/org/unverified',
            description: 'Sellers - Awaiting Admin Approval',
        },
        // {
        //     id: '/inventory/add',
        //     description: 'Add Inventory',
        // },
        // {
        //     id: '/inventory/active',
        //     description: 'Active Inventory',
        // },
        {
            id: '/report',
            description: 'Reports',
        },
        {
            id: '/communications/email',
            description: 'Communications - Email Templates',
        },

        {
            id: '/logs/emailLogs',
            description: 'Communications - Email Logs',
        },

        {
            id: '/messages',
            description: 'Communications - Messages',
        },

        // {
        //     id: '/ordercontrol/cancelled',
        //     description: 'Cancelled',
        // },
        {
            id: '/invoice/all',
            description: 'Invoices - All',
        },

        {
            id: '/invoice/paid',
            description: 'Invoices - Paid',
        },
        {
            id: '/invoice/unpaid',
            description: 'Invoices - Unpaid',
        },
        {
            description: 'Invoices - Expired',
            id: '/invoice/expired',
        },
        {
            id: '/invoice/cancel',
            description: 'Invoices - Cancelled',
        },

        {
            id: '/languageManager',
            description: 'Settings - Language Manager',
        },

        {
            id: '/transaction/payment',
            description: 'Transactions - Payments',
        },

        // {
        //     id: '/subscribers',
        //     description: 'Subscribers',
        // },
        // {
        //     id: '/communications/sms',
        //     description: 'SMS Template',
        // },

        // {
        //     id: '/communications/logs/smsLogs',
        //     description: 'SMS Logs',
        // },

        {
            id: '/dynamic/pages',
            description: 'Dynamic Pages',
        },
        {
            id: '/dynamic/table/pages',
            description: 'Dynamic Tables',
        },
        // {
        //     id: '/plugins',
        //     description: 'Plugins',
        // },
        {
            id: '/disputes',
            description: 'Disputes',
        },
        // {
        //     id: '/settings/palletPricing',
        //     description: 'Pallet Pricing',
        // },
        {
            id: '/settings/faq',
            description: 'Settings - FAQ',
        },
        {
            id: '/settings/banner',
            description: 'Settings - Banner Images',
        },
        {
            id: '/settings/static',
            description: 'Settings - Static Pages',
        },
        {
            id: '/settings/location',
            description: 'Settings - Locations',
        },
        {
            id: '/settings/general',
            description: 'Settings - General',
        },
        {
            id: '/change_password',
            description: 'Account - Change Password',
        },
        {
            id: '/profile',
            description: 'Account - Profile',
        },
        {
            id: '/settings/twoFactor',
            description: 'Account - Two Factor Authentication',
        },
        {
            id: '/db/country',
            description: 'Database - Countries',
        },
        {
            id: '/db/cigars',
            description: 'Database - Cigars',
        },
        {
            description: 'Sellers - Withdrawal Requests',
            id: '/withdrawal_request',
        },
        {
            description: 'Settings - Site Configuration',
            id: '/site_configuration',
        },
        // {
        //     description: 'Currency Configuration',
        //     id: '/currency_configuration',
        // },
        {
            description: 'Settings - Currency Configuration',
            id: '/fixed_rate',
        },

        {
            id: '/management/source',
            description: 'Management - Cigar Sources',
        },
        {
            id: '/management/review',
            description: 'Management - Reviews',
        },
        {
            id: '/db/factory_code',
            description: 'Database - Factory Codes',
        },
        {
            description: 'Database - Disapproval Reasons',
            id: '/db/disapproval_reason',
        },
        { id: '/db/payment_file', description: 'Database - Payment Files' },
        {
            id: '/db/serial_number',
            description: 'Database - Serial Numbers',
        },
    ]
    const [permissionSelect, setPermissionSelect] = useState(permission)

    const validationArray = Yup.object({
        emp_email: Yup.string()
            .email('Invalid email format')
            .required('Required!'),
        confirm_email: Yup.string()
            .email('Invalid email format')
            .oneOf([Yup.ref('emp_email')], 'Email not match')
            .required('Required!'),
        emp_firstname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_lastname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_address1: Yup.string().required('Required!'),
        emp_phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        emp_type: Yup.string().required('Required!'),
        emp_city: Yup.string().required('Required!'),
        emp_state: Yup.string().required('Required!'),
        emp_country: Yup.string().required('Required!'),
        emp_zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'Only numbers are allowed')
            .max(6, 'Postal code must not exceed 6 digits')
            .min(4, 'Postal code must be at least 4 digits')
            .required('Required'),
        emp_permissions: Yup.array().required('Required!'),
    })

    const validationArrayPassword = Yup.object({
        password: Yup.string()
            .min(8, 'Minimum 8 characters')
            .required('Required!'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required!'),
    })
    const [formikValues, setFormikValues] = useState(initialValues)

    const personalDetailsNew = [
        {
            label: 'First name *',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-sm-6 col-12',
            name: 'emp_firstname',
            autoFocus: true,
        },
        {
            label: 'Last Name *',
            placeholder: 'Enter last name',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_lastname',
        },
        {
            label: 'Phone Number *',
            placeholder: 'Enter phone number',
            type: 'phone',
            class: 'col-sm-6 col-12',
            name: 'emp_phone',
        },
        {
            label: 'Employee Type *',
            placeholder: 'Enter employee type',
            class: 'col-sm-6 col-12',
            type: 'select',
            options:
                user.emp_type === 'super_admin'
                    ? [
                          { value: 'super_admin', show: 'Super admin' },
                          { value: 'admin', show: 'Admin' },
                          { value: 'employee', show: 'Employee' },
                      ]
                    : [{ value: 'employee', show: 'Employee' }],
            name: 'emp_type',
        },
    ]

    personalDetailsNew.push(
        {
            label: 'Email Address *',
            placeholder: 'Enter email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_email',
        },
        {
            label: 'Confirm Email Address',
            placeholder: 'Confirm your email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'confirm_email',
        }
    )

    const passwordChange = [
        {
            label: 'Password',
            placeholder: 'Enter Password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Re-Enter Password',
            placeholder: 'Re-Enter password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const locationDetails = [
        {
            label: 'Street Address *',
            placeholder: 'Enter street address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_address1',
        },
        {
            label: 'Country *',
            placeholder: 'Select country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_country',
        },
        {
            label: 'State *',
            placeholder: 'Select state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                ?.filter((state) => {
                    // Ensure that emp_country, defaultCountry, and ignoreStates are defined
                    const empCountry = formikValues?.emp_country || '' // Default to an empty string if undefined
                    const defaultCountry = global?.defaultCountry || '' // Default to an empty string if undefined
                    const ignoreStates = global?.ignoreStates || [] // Default to an empty array if undefined

                    return (
                        // Check if emp_country or defaultCountry is properly defined and contains the countryCode
                        (empCountry
                            ? empCountry.indexOf(state.countryCode) !== -1
                            : defaultCountry.indexOf(state?.countryCode) !==
                              -1) &&
                        // Ensure ignoreStates is an array and check if isoCode is not in ignoreStates
                        ignoreStates.indexOf(state.isoCode) === -1
                    )
                })
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_state',
        },
        {
            label: 'City *',
            placeholder: 'Enter city',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_city',
        },
        {
            label: 'ZIP *',
            placeholder: 'Enter ZIP',
            type: 'number',
            class: 'col-sm-6 col-12',
            name: 'emp_zip',
        },
    ]

    useEffect(() => {
        if (formikValues.emp_type === 'super_admin') {
            permission.push(
                {
                    id: '/employees/all',
                    description: 'Employees - All',
                },
                {
                    id: '/settings/maintanence',
                    description: 'Settings - Maintenance',
                },
                {
                    id: '/settings/category',
                    description: 'Settings - Categories',
                },
                {
                    id: '/settings/bid_increments',
                    description: 'Settings - Bid Increments',
                },
                {
                    id: '/settings/tax_code',
                    description: 'Settings - Tax Codes',
                }
            )
            setPermissionSelect(permission)
        } else if (formikValues.emp_type === 'admin') {
            permission.push({
                id: '/employees/all',
                description: 'Employees - All',
            })
            setPermissionSelect(permission)
        } else {
            setPermissionSelect(permission)
        }
    }, [formikValues.emp_type])

    useEffect(() => {
        setFormikValues(initialValues)
    }, [initialValues])

    const permissionDetails = [
        {
            type: 'check',
            class: 'empPermissions d-flex align-items-center flex-wrap',
            name: 'emp_permissions',
            options: permissionSelect,
        },
    ]

    const formikValueUpdate = (value) => {
        setFormikValues(value)
    }

    const closeFunction = () => {
        resetFrom()
        history.goBack()
    }

    useEffect(() => {
        // getSingleEmployee is denied (403) for records this user may not manage.
        if (
            responseStatusEmployee?.status === 'error' &&
            responseStatusEmployee?.from === 'UserManagement' &&
            responseStatusEmployee?.type === 403 &&
            // Ignore a late denial from an earlier request once this page's record has loaded.
            String(single_employee?.record?.id) !==
                String(props.match?.params?.eid)
        ) {
            setAlert(responseStatusEmployee.message, 'error')
            handleRedirectInternal(history, `employees/all`)
        }
    }, [responseStatusEmployee])

    return (
        <EmployeeForm
            data={props?.data}
            isnotCustom={props?.data ? false : true}
            initialValues={initialValues}
            passwordInitialValues={passwordInitialValues}
            validationArray={validationArray}
            validationArrayPassword={validationArrayPassword}
            permissionDetails={permissionDetails}
            locationDetails={locationDetails}
            passwordChange={passwordChange}
            dynamicPermission={true}
            independentPermissionSave={true}
            personalDetailsNew={personalDetailsNew}
            toggleFullScreenPopup={props.function}
            formikValueUpdate={formikValueUpdate}
            employeeFunctionEdit={employeeFunctionEdit}
            resetFrom={resetFrom}
            custom={props?.custom}
            employeeId={
                props?.match?.params?.eid
                    ? parseInt(props?.match?.params?.eid)
                    : 0
            }
            employeeStatus={'new'}
            closeFunction={closeFunction}
        />
    )
}

export default EmployeeManage
